<div class="modal-overlay" (click)="close.emit()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <div class="header-title-wrapper">
        <h2>📊 Daily Revenue Check</h2>
        <span class="device-badge">{{ deviceName }}</span>
      </div>
      <button class="close-btn" (click)="close.emit()">&times;</button>
    </div>
    
    <div class="modal-body">
      <!-- Date Selector -->
      <div class="date-selector-section">
        <label for="revenueDate" class="input-label">Select Date:</label>
        <div class="date-input-wrapper">
          <input 
            type="date" 
            id="revenueDate" 
            [(ngModel)]="selectedDateStr" 
            (change)="fetchRevenue()"
            class="date-input"
          />
          <button class="refresh-btn" (click)="fetchRevenue()" title="Refresh">🔄</button>
        </div>
      </div>

      <!-- Loading State -->
      <div class="loading-state" *ngIf="isLoading">
        <div class="spinner-small"></div>
        <p>Loading revenue data...</p>
      </div>

      <!-- Content State -->
      <div class="revenue-content" *ngIf="!isLoading && hasLoaded">
        <!-- If data exists -->
        <ng-container *ngIf="revenueData; else noData">
          <div class="revenue-card">
            <span class="card-label">DAILY REVENUE</span>
            <span class="card-value">${{ totalRevenue | number:'1.2-2' }}</span>
          </div>

          <div class="monthly-summary-section" *ngIf="monthlyData">
            <h3>Monthly Total</h3>
            <div class="monthly-grid">
              <div class="monthly-card">
                <span class="monthly-label">TOTAL REVENUE</span>
                <span class="monthly-value">${{ monthlyTotalRevenue | number:'1.2-2' }}</span>
              </div>
              <div class="monthly-card">
                <span class="monthly-label">TOTAL SESSIONS</span>
                <span class="monthly-value">{{ monthlyTotalSessions }}</span>
              </div>
            </div>
          </div>

          <div class="details-section" *ngIf="detailFields.length > 0">
            <h3>Breakdown Details</h3>
            <div class="details-grid">
              <div class="detail-row" *ngFor="let item of detailFields">
                <span class="detail-label">{{ item.label }}</span>
                <span class="detail-value">{{ item.value }}</span>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- If no data -->
        <ng-template #noData>
          <div class="empty-state">
            <div class="empty-icon">📭</div>
            <p class="empty-title">No Data Found</p>
            <p class="empty-subtitle">There is no revenue data recorded for this date.</p>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>
